import React, { useState } from 'react';
import styled from '@nykaa/nes-ui-components/styles/styled';
import { hexToRgb } from '@nykaa/nes-ui-components/styles/utils';
import RecentSearchMan from 'components/Icons/RecentSearchMan';
import RecentSearchBeauty from 'components/Icons/RecentSearchBeauty';
import { getSearchHistory } from 'helpers/utils/search/searchSuggestion';
import { SearchSuggestion } from 'types/searchSuggestion';
import { searchTypes } from 'constants/searchSuggestion';
import Delete from 'components/Icons/Delete';
import { deleteRecentSearch } from '../../helpers/utils/search/searchSuggestion';
import { FormattedMessage } from '@nykaa/nes-intl-shared';
import { RECENT_SEARCHES } from 'constants/strings';


const HistoryContainer = styled.div`
  background-color: ${({ theme }) => theme.colors.surface};
  padding-bottom: ${({ theme }) => theme.spacing.spacing60};
`;

const Title = styled.h4`
  ${({ theme }) => theme.typography.titleXSmall};
  color: ${({ theme }) => theme.colors.textPrimary};
`;

const Item = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px ${({ theme }) => theme.spacing.spacing20};
`;

const Image = styled.img`
  height: 72px;
  width: 72px;
  object-fit: cover;
  border-radius: 8px;
`;

const PlaceholderCtn = styled.div`
  height: 72px;
  width: 72px;
  background-color: ${({ theme }) => hexToRgb(theme.colors.textPrimary, 0.04)};
  border-radius: ${({ theme }) => theme.borders.radius30};
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Name = styled.span`
  ${({ theme }) => theme.typography.bodyMedium}
  width: 72px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  text-align: center;
`;

const Flex = styled.div`
  display: flex;
  flex-direction: row;
  overflow: auto;
  scrollbar-width: none;
  padding: 0px ${({ theme }) => theme.spacing.spacing80};
  &::-webkit-scrollbar {
    display: none;
  }
`;

const TitletWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.spacing80};
`;

const IconWrapper = styled.button`
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
`;

interface Props {
  handleClick: (suggestion: SearchSuggestion, position: number) => void;
};


const RenderImage = (path: string, altText: string): JSX.Element => {
  if (!path) {
    return (
      <PlaceholderCtn>
        {(__PLATFORM__ === 'men') ? <RecentSearchMan /> : <RecentSearchBeauty />}
      </PlaceholderCtn>
    );
  }
  return <Image src={path} alt={altText} />;
};


function HistoryChips({
  handleClick,
}: Props) {
  const [recentItems, setRecentItems] = useState(getSearchHistory());

  const clickHandler = (searchSuggestion: SearchSuggestion, position: number) => {
    searchSuggestion.listItemType = searchTypes.HISTORY;
    const searchItem = {
      ...searchSuggestion,
      id: position?.toString(),
    };

    handleClick(searchItem, position);
  };

  const handleOnDelete = () => {
    deleteRecentSearch();
    setRecentItems([]);
  };

  if (recentItems && (recentItems.length > 0)) {
    return (
      <HistoryContainer>
        <TitletWrapper>
          <Title><FormattedMessage id={RECENT_SEARCHES} /></Title>
          <IconWrapper onClick={handleOnDelete}>
            <Delete />
          </IconWrapper>
        </TitletWrapper>
        <Flex>
          {
            recentItems.map((recentItem, index) => {
              const { q, image = '' } = recentItem;
              return (
                <Item key={index} onClick={() => clickHandler(recentItem, index + 1)}>
                  {RenderImage(image, q)}
                  <Name>{q}</Name>
                </Item>
              );
            })
          }
        </Flex>
      </HistoryContainer>
    );
  }

  return null;
}

export default HistoryChips;
